import type { ToolApproval } from '@kirin/api-client/contracts/shadow-ai-tool-approvals';
import { formatZonedDate } from '@/lib/date-utils';

/** "by Jane Doe, September 20, 2026" — approver removed since → "by a removed user". */
export function formatApprovedBy(
  approval: ToolApproval,
  timeZone: string
): string {
  const name = approval.approvedByName?.trim() || 'a removed user';
  const date = formatZonedDate(approval.approvedAt, timeZone, '');
  return date ? `by ${name}, ${date}` : `by ${name}`;
}
